const version = '2.0.2'
export default version



// WEBPACK FOOTER //
// ./src/util/version.js